import { byMedia } from '../helpers/media';
export var overflowHidden = byMedia(function (value) {
  return value ? "overflow: hidden;" : '';
});